module.exports = __webpack_public_path__ + "static/media/item4.5293ad81.png";